import type React from 'react';
import { useEffect, useState } from 'react';
import logo from '../assets/Final-Concept-12.png';
import './LoadingScreen.css';

const HIDE_DELAY_MS = 1600;
const DONE_DELAY_MS = 2100;

interface LoadingScreenProps {
  onDone: () => void;
}

export default function LoadingScreen({ onDone }: LoadingScreenProps): React.JSX.Element {
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    const hideTimer = setTimeout(() => setHiding(true), HIDE_DELAY_MS);
    const doneTimer = setTimeout(onDone, DONE_DELAY_MS);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <div
      className={`loading-screen${hiding ? ' loading-screen--hide' : ''}`}
      role="status"
      aria-label="Loading"
      aria-live="polite"
    >
      <img src={logo} alt="" className="loading-logo" aria-hidden="true" />
    </div>
  );
}
